class MenuDesktop {
    constructor() {
        resizeCallbacks.push(this);
        this.build();
    }

    build() {
        if (window.innerWidth >= 1100) {
            this.lev1Items = document.querySelectorAll(".menu-item-has-children");

            this.lev1Items.forEach(item => {
                item.addEventListener('mouseenter', this.showLevel2);
                item.addEventListener('mouseleave', this.hideLevel2);
            });
        }
    }

    showLevel2(event) {
        event.target.querySelector('.menu-lev2').classList.add('show');
    }

    hideLevel2(event) {
        event.target.querySelector('.menu-lev2').classList.remove('show');
    }

    resize() {
        this.destroy();
        this.build();
    }

    destroy() {
        if (this.lev1Items) {
            this.lev1Items.forEach(item => {
                item.removeEventListener('mouseenter', this.showLevel2);
                item.removeEventListener('mouseleave', this.hideLevel2);
            });
        }
    }
}